'use client';

import {
  Form,
  FormProps,
  useFormMethods,
} from '@sola/ark-core/molecules/form/form.js';

export type PaymentMethodAddFormProps = {
  children?: React.ReactNode;
  onSubmit: FormProps['onSubmit'];
};

export const PaymentMethodAddForm: React.FC<PaymentMethodAddFormProps> = ({
  children,
  onSubmit,
}) => {
  const formMethods = useFormMethods();

  return (
    <Form
      onSubmit={onSubmit}
      formMethods={formMethods}
      options={{ mode: 'onTouched' }}
      isCustomError
      noValidate
    >
      {children}
    </Form>
  );
};
